// hooks/useAutoLogout.js
import { useEffect, useRef } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export function useAutoLogout(user, timeoutMs = 3600000) { // 1小時=3600000ms
  const timer = useRef();

  useEffect(() => {
    if (!user) return;

    const resetTimer = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        signOut(auth);
        alert("You have been logged out due to inactivity.");
      }, timeoutMs);
    };

    // 監聽所有互動事件
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach(e => window.addEventListener(e, resetTimer));

    resetTimer(); // 初始啟動

    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [user, timeoutMs]);
}
